import { createFileRoute } from '@tanstack/react-router';
import { OwnersClient } from '@/features/fuel/OwnersClient';

export const Route = createFileRoute('/_shell/fuel/owners')({
  component: OwnersClient,
});
